<template>
  <div class="tk-image-view" ref="tk-image-view">
    <video-player
      v-if="selectedVideo && artwork.video_id"
      :videoId="artwork.video_id"
    />

    <template v-else>
      <!-- Setting srcset to null when on zoom mode so that the full image is loaded -->
      <v-img
        v-if="selectedImage"
        contain
        ref="artwork-image"
        class="artwork-image mb-1"
        max-height="100%"
        sizes="(max-width: 959px) 100vw, 824px"
        :src="selectedImage.url"
        :srcset="showZoomImage ? null : selectedImage.srcset"
        :class="{ 'zoom-image': showZoomImage }"
        @click="showZoomImage = false"
        @mouseleave="
          showZoomImage = false;
          showArrrowButtons = false;
        "
        @touchend="showZoomImage = false"
        @mousemove="moveLens"
        @touchmove="moveLens"
        @touchstart="onImageClick"
        @mouseover="onMouseover"
      >
        <div class="text-xs-right">
          <tk-btn
            v-if="$vuetify.breakpoint.mdAndUp"
            small
            aria-label="Zoom in"
            dark
            class="zoom-btn"
            @click="onZoomBtnClick"
          >
            <v-icon size="1.0rem">fas fa-search-plus</v-icon>
          </tk-btn>
        </div>
        <!-- Arrow buttons -->
        <ImageCarouselsButtons
          v-if="showArrrowButtons && !showZoomImage"
          :artwork="artwork"
          @prev="previousImage()"
          @next="nextImage()"
        />
      </v-img>
    </template>
  </div>
</template>

<script>
import ImageCarouselsButtons from "./ImageCarouselsButtons";
import VideoPlayer from "../../Video/VideoPlayer.vue";

export default {
  props: {
    artwork: { required: true },
  },

  components: {
    ImageCarouselsButtons,
    VideoPlayer,
  },

  data() {
    return {
      showZoomImage: false,
      showArrrowButtons: false,
    };
  },

  created() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.showArrrowButtons = true;
    }
  },

  computed: {
    curImgId() {
      if (this.$route.query.img) {
        return this.$route.query.img;
      } else {
        if (this.artwork.media && this.artwork.media.length) {
          return this.artwork.media[0].id;
        }
      }
      return null;
    },

    thumbnailHeight() {
      if (this.$vuetify.breakpoint.xsOnly) return "40px";
      else if (this.$vuetify.breakpoint.smOnly) return "80px";
      return "100px";
    },

    selectedImage() {
      const pos = this.artwork.media.findIndex((m) => m.id === this.curImgId);
      if (pos !== -1) return this.artwork.media[pos];
      return this.artwork.media[0]; // By default show firt image
    },

    selectedVideo() {
      return this.$route.query.video;
    },
  },

  methods: {
    moveLens(e) {
      if (!this.showZoomImage) return;

      e.preventDefault();

      const el = this.$refs["artwork-image"]
        ? this.$refs["artwork-image"].$el
        : null;

      // check if element has childnodes
      if (el && el.childNodes) {
        const nodes = [...el.childNodes]; // make an array of out of an object if the object is iterable.

        // Find element that contain image as background
        const imageContainEl = nodes.find((node) => {
          const classes = [...node.classList];
          // Vuetify loads image with class name 'v-image__image--contain'
          return classes.includes("v-image__image--contain");
        });

        imageContainEl.style.backgroundSize = this._zoomFactor;

        // Find image dimension
        const imgDimensions = imageContainEl.getBoundingClientRect();

        // Find client x y for touch screen and mouse screen
        const clientX = this.isTouchmove(e) ? e.touches[0].clientX : e.clientX;
        const clientY = this.isTouchmove(e) ? e.touches[0].clientY : e.clientY;

        // Calculate position of cursor relative to the image in pixels
        const x = clientX - imgDimensions.left;
        const y = clientY - imgDimensions.top;

        // Get the position of the cursor as a percentage of the total image size
        const percentX = Math.round(100 / (imgDimensions.width / x));
        const percentY = Math.round(100 / (imgDimensions.height / y));

        if (
          percentX >= 0 &&
          percentX <= 100 &&
          percentY >= 0 &&
          percentY <= 100
        ) {
          // Move backgound image position
          imageContainEl.style.backgroundPosition = `${percentX}% ${percentY}%`;
        }
      }
    },

    isTouchmove(e) {
      return e.type === "touchmove";
    },

    onZoomBtnClick(e) {
      e.stopPropagation();
      this.showZoomImage = true;
    },

    onImageClick(e) {
      console.log("onImageCLicked", e, e.target.classList, e.target.tagName);
      if (e && e.target && e.target.tagName) {
        if (e.target.classList.contains("v-btn__content")) return;

        if (e.target.tagName.toLowerCase() === "div") {
          console.log("Current status", this.showArrrowButtons);
          this.showArrrowButtons = !this.showArrrowButtons;
          console.log("Current status", this.showArrrowButtons);
        }
      }
    },

    onMouseover(e) {
      if (this.$vuetify.breakpoint.smAndDown) return;
      this.showArrrowButtons = true;
    },

    previousImage() {
      const totalImagesCount = this.artwork.media.length;
      const curPos = this.artwork.media.findIndex(
        (m) => m.id === this.curImgId
      );

      let newMediaId = null;

      if (curPos < totalImagesCount - 1) {
        newMediaId = this.artwork.media[curPos + 1].id;
      } else if (curPos === totalImagesCount - 1) {
        newMediaId = this.artwork.media[0].id;
      }

      if (newMediaId) {
        this.$router.push({
          path: this.artwork.path,
          query: { img: newMediaId },
        });
      }
    },

    nextImage() {
      const totalImagesCount = this.artwork.media.length;
      const curPos = this.artwork.media.findIndex(
        (m) => m.id === this.curImgId
      );

      let newMediaId = null;

      if (curPos === 0) {
        newMediaId = this.artwork.media[totalImagesCount - 1].id;
      } else {
        newMediaId = this.artwork.media[curPos - 1].id;
      }

      if (newMediaId) {
        this.$router.push({
          path: this.artwork.path,
          query: { img: newMediaId },
        });
      }
    },
  },
};
</script>


<style  lang="scss">
.tk-image-view {
  width: 100%;
  .artwork-image {
    max-width: 100%;
    max-height: 820px;

    &.zoom-image {
      .v-image__image--contain {
        background-size: 350%;
      }

      cursor: move;
    }
  }

  .zoom-btn {
    min-width: 24px;
  }
}
</style>
